import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { EMPTY, catchError, throwError } from 'rxjs';
import { ColleagueHandoffFacade } from '../../../Facades/colleague-handoff.facade';
import { COMPLETED_BY_COLLEAGUE_KEY } from '../../../Consts/onboarding-error-keys.const';

export const colleagueCompletedInterceptor: HttpInterceptorFn = (req, next) => {
  const handoff = inject(ColleagueHandoffFacade);
  const router = inject(Router);

  return next(req).pipe(
    catchError((error: unknown) => {
      if (
        !(error instanceof HttpErrorResponse) ||
        error.status !== 409 ||
        error.error?.message !== COMPLETED_BY_COLLEAGUE_KEY
      ) {
        return throwError(() => error);
      }

      const url = error.error?.data?.redirect_url;
      handoff.setRedirectUrl(typeof url === 'string' && url !== '' ? url : null);
      router.navigateByUrl('/colleague-completed');
      return EMPTY;
    }),
  );
};
